import { formattedDateForSubscription } from '@talos/kyoko';
import type { InitiateTransferParams } from './TransfersContext';

/** REST create body for POST /transfers (`types.NewTransfer`). Not internal `ITransferRequest`. */
export interface InitiateTransferRequestBody {
  ClientID: string;
  Currency: string;
  ChainCurrencySymbol: string | undefined;
  Amount: string;
  Market: string;
  TransactTime: string;
  FromMarketAccountID: number | undefined;
  ToMarketAccountID: number | undefined;
  FromSourceAccountID: string | undefined;
  ToSourceAccountID: string | undefined;
  Description: string;
  ReferenceData: string;
  TreatAsGrossAmount?: boolean;
}

export function buildTransferRequestBody({
  clientID,
  currency,
  chainCurrency,
  amount,
  market,
  fromMarketAccountID,
  toMarketAccountID,
  fromSourceAccountID,
  toSourceAccountID,
  description,
  reference,
  transactTime = new Date(),
  treatAsGrossAmount,
}: InitiateTransferParams): InitiateTransferRequestBody {
  return {
    ClientID: clientID,
    Currency: currency,
    ChainCurrencySymbol: chainCurrency,
    Amount: amount,
    Market: market,
    TransactTime: formattedDateForSubscription(transactTime),
    FromMarketAccountID: fromMarketAccountID,
    ToMarketAccountID: toMarketAccountID,
    FromSourceAccountID: fromSourceAccountID,
    ToSourceAccountID: toSourceAccountID,
    Description: description,
    ReferenceData: reference,
    TreatAsGrossAmount: treatAsGrossAmount,
  };
}
